import mergeOperations from "@/util/shallowMerge"
import {
  useLazyQuery 
} from "@apollo/client"
import {
  useEffect 
} from "react"
import DEFAULT_OPERATIONS from "../../hooks/Category/category.gql"

const pageSize = 36

export const useItemModal = (props) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)
  const {
    getCategoryQuery 
  } = operations

  const {
    item 
  } = props

  const {
    colors, skus 
  } = item

  const [runQuery, {
    loading, error, data 
  }] = useLazyQuery(
    getCategoryQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  useEffect(() => {
    const filters = {}

    const skuList = skus.split(",")

    filters["skus"] = {
      in: skuList 
    }

    runQuery({
      variables: {
        currentPage: 1,
        id: "NQ==",
        filters,
        pageSize: Number(pageSize),
      },
    })
  }, [skus])

  return {
    products: data?.products?.items,
    colors,
  }
}
